import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectIsAuthenticated } from "../../authentication/authenticationSlice";
import { selectOrganization } from "../organization-slice";
import { fetchCurrentOrganization } from "../slice-extensions/organization-slice-extension";
import { setActiveVocabulary } from "../utils/vocabularyI18n";
import { ROUTES } from "../../../routes";

/**
 * Loads the signed-in instructor's organization once (every role) and pushes
 * its vocabulary into i18next, so the whole app speaks the school's words.
 * Signed out, or before the organization loads, the Default preset applies.
 * The member portal pushes its own member's organization words instead.
 */
const OrganizationVocabularySync = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const organization = useAppSelector(selectOrganization);
  const requested = useRef(false);
  const onPortal = useLocation().pathname.startsWith(ROUTES.PORTAL);
  const vocabulary = isAuthenticated ? organization?.vocabulary ?? null : null;

  useEffect(() => {
    if (!isAuthenticated) {
      requested.current = false;
      return;
    }
    if (organization || requested.current) {
      return;
    }
    requested.current = true;
    dispatch(fetchCurrentOrganization());
  }, [dispatch, isAuthenticated, organization]);

  useEffect(() => {
    if (onPortal) return;
    setActiveVocabulary(i18n, vocabulary);
  }, [i18n, vocabulary, onPortal]);

  return null;
};

export default OrganizationVocabularySync;
